module.exports = __webpack_public_path__ + "img/MCS_Logos_ENG.54e6dd41.png";